import { exchangeKeyVInObj } from '@utils/common';
import { INSIGHT_SEGMENTS } from './insights';

export const stockTimeRangeBtns = [
  {
    type: 'year',
    count: 5,
    text: '5y',
  },
  {
    type: 'year',
    count: 3,
    text: '3y',
  },

  {
    type: 'year',
    count: 1,
    text: '1y',
  },
];

export const marketcapTimeRangeBtns = [
  {
    type: 'year',
    count: 5,
    text: '5y',
  },
  {
    type: 'year',
    count: 3,
    text: '3y',
  },
  {
    type: 'year',
    count: 1,
    text: '1y',
  },
];

export const stockViarietyModel = stockTimeRangeBtns.map(
  (btn) => `${btn.type}${btn.count}Change`,
);

export const marketcapViarietyModel = marketcapTimeRangeBtns.map(
  (btn) => `${btn.type}${btn.count}Change`,
);

export const insightMenuAcions = {
  EDIT: 'Edit',
  // ADDINSIGHT: 'Add Insight',
  VIEWINSIGHT: 'View Insight',
};

export const SEGMENTS = {
  companyoverview: 'Company Overview',
  financials: 'Financials',
  gotomarket: 'Go-To-Market',
  operationalfootprint: 'Operational Footprint',
  sentimentanalysis: 'Sentiment Analysis',
  // cyberSecurity: 'Cybersecurity',
  esgAndCsr: 'ESG',
};

export const GotomarketDeafultFields = [
  'Products',
  'Services',
  'Brands',
  'Target Customers (industry)',
  'Target Customers (segment)',
  'Competitors',
];

export const ANALYSIS_SUB_PERMISSIONS = Object.fromEntries(
  Object.keys(SEGMENTS).map((i) => [i, i]),
);

export const ParentAndChildItemMap = new Map();
ParentAndChildItemMap.set('SG&A Expense', [
  'General and Administrative',
  'Sales and Marketing',
]);
ParentAndChildItemMap.set('Employee Headcount', [
  'Financial Statement',
  'Dun & Bradstreet',
]);

// const isNativeAnalysisModule = (e) => Object.keys(SEGMENTS).includes(e);

export const getMenuList = ({
  // isClient,
  // sectionsPermission,
  // internalSectionsPermission,
  originPermissions = [],
  permissionCodes = [],
}) =>
  // const { analysisPermission } = sectionsPermission;
  // const { analysisPermission: internalPermission } = internalSectionsPermission;

  // if (!isClient) {
  //   return internalPermission.filter(isNativeAnalysisModule).map((m) => ({
  //     id: m,
  //     title: SEGMENTS[m] || INSIGHT_SEGMENTS[m],
  //   }));
  // }
  originPermissions?.length
    ? originPermissions
        .filter((i) => permissionCodes?.includes(i.value))
        .map((i) => ({
          id: i.value,
          title: i.label,
        }))
    : Object.keys(SEGMENTS)
        .filter((i) => permissionCodes?.includes(i))
        .map((i) => ({
          id: i,
          title: SEGMENTS[i] || INSIGHT_SEGMENTS[i],
        }))
        .filter((i) => i.title);

export const exchangeKeyVInSegments = exchangeKeyVInObj(SEGMENTS);

export const CSTMZ_SEGMENTS = [
  SEGMENTS.sentimentanalysis,
  SEGMENTS.esgAndCsr,
  SEGMENTS.cyberSecurity,
];

export const UNCLICKABLE_RESOURCE_NAME = [
  undefined,
  'Currency',
  'Sales Growth YoY',
  'Gross Margin',
  'General and Administrative',
  'Sales and Marketing',
  'Operating Expense',
  'Enterprise Value',
  'Auditor',
  'Company Name',
  'Parent Company',
  'Company Website',
  'Public/Private',
  'Industry',
  'Incorporation Year',
  'Products',
  'Services',
  'Brands',
  'Competitors',
  'Target Customers (industry)',
  'Target Customers (segment)',
  'HQ LE',
  'Note',
];

export const getSegmentIdByName = (name) => {
  let key = '';
  Object.entries(SEGMENTS).forEach(([index, value]) => {
    if (value === name) {
      key = index;
    }
  });

  return key;
};

export const COMPANY_HISTORY_CATEGORIES = [
  'New Products/Services',
  'Contracts/Agreements',
  'Acquisitions/Mergers/Takeovers',
  'Litigation',
  'Divestiture',
  'Incorporation/Establishment',
  'Other',
];

export const COMPANY_HISTORY_CATEGORY_IDS = {
  'New Products/Services': '1',
  'Contracts/Agreements': '2',
  'Acquisitions/Mergers/Takeovers': '3',
  Litigation: '4',
  Divestiture: '5',
  'Incorporation/Establishment': '6',
  Other: '7',
};

export const subsidiaryStaticData = {
  HP: [
    {
      company: '3Com Corporation',
      description:
        'HQ: Marlborough, Massachusetts | United States; Primary Industry: Communications Equipment',
    },
    {
      company: '3 Com Israel Ltd.',
      description:
        'HQ: Lod | Israel; Primary Industry: Communications Equipment',
    },
    {
      company: '3com (Schweiz) Ag',
      description: 'HQ: Zürich, Zurich | Switzerland',
    },
    {
      company: '3Com (Thailand) Co., Ltd.',
      description: 'HQ: Bangkok | Thailand',
    },
    {
      company: '3Com Asia Ltd.',
      description: 'HQ: Taikoo Shing | Hong Kong',
    },
    {
      company: '3Com Asia Pacific Rim PTE Limited',
      description: 'HQ: Singapore | Singapore',
    },
    {
      company: '3Com Australia & New Zealand Ltd.',
      description: 'HQ: Melbourne, Victoria | Australia',
    },
    {
      company: '3com Australia Pty Ltd',
      description:
        'HQ: North Sydney, New South Wales | Australia; Primary Industry: Communications Equipment',
    },
    {
      company: '3Com Benelux B.V.',
      description: 'HQ: Maarssen, Utrecht | Netherlands',
    },
    {
      company: '3Com Bilgisayar Ticaret A.S.',
      description: 'HQ: Istanbul | Turkey',
    },
    {
      company: '3com Canada Inc',
      description:
        'HQ: Oakville, Ontario | Canada; Primary Industry: Communications Equipment',
    },
    {
      company: '3Com Ges.m.b.H.',
      description: 'HQ: Wien, Vienna | Austria',
    },
    {
      company: '3com Gesellschaft Mit Beschrankter Haftung',
      description:
        'HQ: Aschheim | Germany; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: '3com Gmbh, Munchen, Zweigniederlassung Bern',
      description:
        'HQ: Bern, Bern | Switzerland; Primary Industry: Technology Distributors',
    },
    {
      company: '3Com Holdings Limited',
      description: 'HQ: George Town, Grand Cayman | Cayman Islands',
    },
    {
      company: '3com Iberia Sa (Extinguida)',
      description: 'HQ: Madrid, Madrid | Spain; Primary Industry: Distributors',
    },
    {
      company: '3Com India Pvt. Ltd.',
      description: 'HQ: New Delhi, Delhi | India',
    },
    {
      company: '3Com Italia S.p.A.',
      description:
        'HQ: Cologno Monzese, Milan | Italy; Primary Industry: Technology Distributors',
    },
    {
      company: '3Com Korea Ltd.',
      description:
        'HQ: Seoul | South Korea; Primary Industry: Communications Equipment',
    },
    {
      company: '3Com Ltd.',
      description: 'HQ: Moscow | Russia',
    },
    {
      company: '3Com Nordic AB',
      description:
        'HQ: Vantaa | Finland; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: '3com Philippines, Inc.',
      description:
        'HQ: Philippines; Primary Industry: Communications Equipment',
    },
    {
      company: '3com Technologies',
      description: 'HQ: Cayman Islands',
    },
    {
      company: 'U S Robotics Middle East Holdings, Inc.',
      description: 'HQ: United States; Primary Industry: Industrial Machinery',
    },
    {
      company: 'Apogee Corporation Limited',
      description:
        'HQ: Maidstone, Kent | United Kingdom; Primary Industry: Internet Services and Infrastructure',
    },
    {
      company: 'Apogee France',
      description:
        'HQ: Asnieres-Sur-Seine, Ile-de-France | France; Primary Industry: Trading Companies and Distributors',
    },
    {
      company: 'BAS Bürosysteme GmbH',
      description:
        'HQ: Laatzen, Lower Saxony | Germany; Primary Industry: Technology Distributors',
    },
    {
      company: 'The Danwood Group Ltd.',
      description:
        'HQ: Maidstone, Kent | United Kingdom; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'Printware Limited',
      description:
        'HQ: Portsmouth | United Kingdom; Primary Industry: Office Services and Supplies',
    },
    {
      company: 'Apogee Europe Limited',
      description:
        'HQ: Maidstone, Kent | United Kingdom; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'Apogee France S.A.S',
      description:
        'HQ: Osny, Ile-de-France | France; Primary Industry: Trading Companies and Distributors',
    },
    {
      company: 'Apsylog S.A.',
      description:
        'HQ: Paris, Ile-de-France | France; Primary Industry: Application Software',
    },
    {
      company: 'Avantek Inc.',
      description:
        'HQ: Santa Clara, California | United States; Primary Industry: Semiconductors',
    },
    {
      company: 'BAS - Büosysteme GmbH',
      description: 'HQ: Germany',
    },
    {
      company: 'bilderservice.de GmbH',
      description:
        'HQ: Jena, Thuringia | Germany; Primary Industry: Interactive Media and Services',
    },
    {
      company: 'Bromium Inc.',
      description:
        'HQ: Cupertino, California | United States; Primary Industry: Systems Software',
    },
    {
      company: 'Bromium UK Limited',
      description: 'HQ: United Kingdom',
    },
    {
      company: 'CERJAC Telecom Operation',
      description:
        'HQ: Acton, Massachusetts | United States; Primary Industry: Communications Equipment',
    },
    {
      company: 'China HP Co. Ltd.',
      description: 'HQ: Beijing | China',
    },
    {
      company: 'Compaq Cayman Holdings Company',
      description: 'HQ: George Town, Grand Cayman | Cayman Islands',
    },
    {
      company: 'Compaq Computer (Delaware) LLC',
      description: 'HQ: Palo Alto, California | United States',
    },
    {
      company: 'Compaq Computer B.V.',
      description: 'HQ: Netherlands',
    },
    {
      company: 'Compaq Computer Caribbean Inc',
      description: 'HQ: United States',
    },
    {
      company: 'Compaq Computer Deutschland GmbH (Holding)',
      description: 'HQ: Germany',
    },
    {
      company: 'Compaq Computer Holding Limited',
      description: 'HQ: Switzerland',
    },
    {
      company: 'Compaq Latin America Corporation',
      description:
        'HQ: Palo Alto, California | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'ConteXtream, Inc.',
      description:
        'HQ: Mountain View, California | United States; Primary Industry: Application Software',
    },
    {
      company: 'David 3D Solutions GbR',
      description:
        'HQ: Braunschweig, Lower Saxony | Germany; Primary Industry: Electronic Equipment and Instruments',
    },
    {
      company: 'David Vision Systems GmbH',
      description:
        'HQ: Koblenz, Rhineland-Palatinate | Germany; Primary Industry: Electronic Equipment and Instruments',
    },
    {
      company: 'E.D.S. Spectrum Corporation',
      description: 'HQ: Plano, Texas | United States',
    },
    {
      company: 'Edisa Hewlett-Packard S.A',
      description:
        'HQ: Barueri, São Paulo | Brazil; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'EDS (Australia) Superannuation Fund Pty. Ltd.',
      description: 'HQ: Melbourne, Victoria | Australia',
    },
    {
      company: 'EDS Japan LLC',
      description: 'HQ: Tokyo | Japan',
    },
    {
      company: 'EDS South LLC',
      description: 'HQ: Plano, Texas | United States',
    },
    {
      company: 'Escador GmbH',
      description:
        'HQ: Munich, Bavaria | Germany; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'ExcellerateHRO World Services LLC',
      description: 'HQ: Plano, Texas | United States',
    },
    {
      company: 'Fortify International, Inc.',
      description: 'HQ: San Mateo, California | United States',
    },
    {
      company: 'Global E-Business Operations Centre Srl',
      description:
        'HQ: Bucuresti | Romania; Primary Industry: Research and Consulting Services',
    },
    {
      company: 'Hanover Asia-Pacific Investment Ltd.',
      description: 'HQ: United States',
    },
    {
      company: 'Hewlett Packard Comercial Do Brasil Ltda',
      description:
        'HQ: Barueri, São Paulo | Brazil; Primary Industry: Technology Distributors',
    },
    {
      company: 'Hewlett Packard Distributed Computing Services S.r.l.',
      description:
        'HQ: Rome, Rome | Italy; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'Hewlett Packard Enterprise Luxembourg S.C.A.',
      description: 'HQ: Luxembourg; Primary Industry: MultiSector Holdings',
    },
    {
      company: 'Hewlett Packard International B.V.',
      description: 'HQ: Amstelveen, Noord-Holland | Netherlands',
    },
    {
      company: 'Hewlett Packard Managed Services Division',
      description: 'HQ: United States',
    },
    {
      company: 'Hewlett-Packard (China) Investment Co., Ltd.',
      description: 'HQ: China',
    },
    {
      company: 'Hewlett-Packard (Chongqin) Co.,Ltd',
      description:
        'HQ: Chongqing | China; Primary Industry: Office Services and Supplies',
    },
    {
      company: 'Hewlett-Packard (Chongqing) Co., Ltd',
      description: 'HQ: Chongqing | China',
    },
    {
      company: 'Hewlett-Packard (Manufacturing) Ltd.',
      description:
        'HQ: Dublin, Co. Dublin | Ireland; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Hewlett-Packard (Vietnam) Ltd.',
      description:
        'HQ: Ho Chi Minh | Vietnam; Primary Industry: Technology Distributors',
    },
    {
      company: 'Hewlett-Packard Angola, LDA',
      description: 'HQ: Angola',
    },
    {
      company: 'Hewlett-Packard AP (Hong Kong) Limited',
      description:
        'HQ: Quarry Bay | Hong Kong; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'Hewlett-Packard Australia Consolidated Pty Ltd',
      description: 'HQ: Australia',
    },
    {
      company: 'Hewlett-Packard Australia Holdings Pty Ltd.',
      description: 'HQ: Victoria | Australia',
    },
    {
      company: 'Hewlett-Packard Benelux BV',
      description: 'HQ: Netherlands',
    },
    {
      company: 'Hewlett-Packard Brazil Holdings, LLC',
      description: 'HQ: Palo Alto, California | United States',
    },
    {
      company: 'Hewlett-Packard CDS Ireland Ltd.',
      description:
        'HQ: Swords, Co. Dublin | Ireland; Primary Industry: Technology Distributors',
    },
    {
      company: 'Hewlett-Packard Centre de Competences, France SaS',
      description:
        'HQ: Les Ulis, Ile-de-France | France; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Hewlett-Packard Cervin Sarl',
      description: 'HQ: Switzerland',
    },
    {
      company: 'Hewlett-Packard Norge Holding As',
      description: 'HQ: Oslo, Buskerud | Norway',
    },
    {
      company: 'Hewlett-Packard Computadores Ltda.',
      description:
        'HQ: Campinas, São Paulo | Brazil; Primary Industry: Systems Software',
    },
    {
      company: 'Hewlett-Packard Computer Products (Shanghai) Co., Ltd.',
      description:
        'HQ: Shanghai | China; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Hewlett-Packard Consultoria Y Aplicaciones EspaÑa Sl',
      description: 'HQ: Spain',
    },
    {
      company: 'Hewlett-Packard Credit Corporation',
      description: 'HQ: United States; Primary Industry: Specialized Finance',
    },
    {
      company: 'Hewlett-Packard Development Company, L.P.',
      description:
        'HQ: Houston, Texas | United States; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Hewlett-Packard Dublin (Holdings) Limited',
      description: 'HQ: Naas | Ireland; Primary Industry: MultiSector Holdings',
    },
    {
      company: 'Hewlett-Packard Financial Services Holding Company Ltd',
      description:
        'HQ: Leixlip | Ireland; Primary Industry: Asset Management and Custody Banks',
    },
    {
      company:
        'Hewlett-Packard Financial Services Company Designated Activity Company',
      description:
        'HQ: Naas | Ireland; Primary Industry: Thrifts and Mortgage Finance',
    },
    {
      company: 'Hewlett-Packard East Africa Limited',
      description:
        'HQ: Nairobi | Kenya; Primary Industry: Technology Distributors',
    },
    {
      company: 'Hewlett-Packard Emea B.v.',
      description:
        'HQ: Amstelveen | Netherlands; Primary Industry: Technology Distributors',
    },
    {
      company: 'Hewlett-Packard Emea Gmbh',
      description: 'HQ: Boblingen | Germany',
    },
    {
      company: 'Hewlett-Packard Enterprises, LLC',
      description: 'HQ: Palo Alto, California | United States',
    },
    {
      company:
        'Hewlett-Packard Erste Vermögensverwaltungs- und Beteiligungsgesellschaft mbH',
      description:
        'HQ: Böblingen, Baden-Württemberg | Germany; Primary Industry: Specialized Finance',
    },
    {
      company: 'Hewlett-Packard Española, S.L.',
      description:
        'HQ: Las Rozas, Madrid | Spain; Primary Industry: Technology Distributors',
    },
    {
      company: 'Hewlett-Packard Europa Holding B.V.',
      description:
        'HQ: Böblingen, Baden-Württemberg | Germany; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Hewlett-Packard Europe B.V.',
      description:
        'HQ: Amstelveen, Noord-Holland | Netherlands; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Hp Europe Bv, Amsterdam, Succursale De Meyrin',
      description:
        'HQ: Meyrin | Switzerland; Primary Industry: Specialized Finance',
    },
    {
      company: 'HP Global e-Business Operations Pvt. Ltd.',
      description:
        'HQ: Bengaluru, Karnataka | India; Primary Industry: Office Services and Supplies',
    },
    {
      company: 'Hewlett-Packard Finance Company',
      description:
        'HQ: Palo Alto, California | United States; Primary Industry: Consumer Finance',
    },
    {
      company: 'Hewlett-Packard Galway Limited',
      description:
        'HQ: Galway, Co. Galway | Ireland; Primary Industry: Systems Software',
    },
    {
      company: 'Hewlett-Packard Global Holdings B.V.',
      description: 'HQ: Netherlands',
    },
    {
      company: 'Hewlett-Packard Global Investments B.V.',
      description:
        'HQ: Amstelveen, Noord-Holland | Netherlands; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'Hewlett-Packard Bergen B.v.',
      description: 'HQ: Amstelveen, Noord-Holland | Netherlands',
    },
    {
      company: 'Hewlett-Packard Gotham B.V.',
      description:
        'HQ: Amstelveen, Noord-Holland | Netherlands; Primary Industry: MultiSector Holdings',
    },
    {
      company: 'Hewlett-Packard Dusseldorf B.V.',
      description: 'HQ: Netherlands; Primary Industry: MultiSector Holdings',
    },
    {
      company: 'Compaq Computer Holdings Limited',
      description:
        'HQ: Richmond, Surrey | United Kingdom; Primary Industry: MultiSector Holdings',
    },
    {
      company: 'Hewlett-Packard Plano, Llc',
      description: 'HQ: United States',
    },
    {
      company: 'Hewlett-Packard Holding GmbH',
      description:
        'HQ: Böblingen, Baden-Württemberg | Germany; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Hewlett-Packard Holding Iberia Sl',
      description: 'HQ: Spain',
    },
    {
      company: 'Hewlett-Packard Hong Kong Limited',
      description: 'HQ: Hong Kong | Hong Kong',
    },
    {
      company: 'Hewlett-Packard Immobilien GmbH',
      description: 'HQ: Boeblingen, Baden-Württemberg | Germany',
    },
    {
      company: 'Hewlett-Packard India Sales Private Limited',
      description:
        'HQ: Bengaluru, Karnataka | India; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'Hewlett-Packard India Software Operation Pvt. Ltd.',
      description:
        'HQ: Bengaluru, Karnataka | India; Primary Industry: Application Software',
    },
    {
      company: 'Hewlett-Packard Indigo B.V.',
      description:
        'HQ: Maastricht, Limburg | Netherlands; Primary Industry: Industrial Machinery',
    },
    {
      company: 'Hewlett-Packard Indigo Ltd.',
      description:
        'HQ: Rehovot | Israel; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Hewlett-Packard Industrial Printing Ltd',
      description: 'HQ: Israel',
    },
    {
      company: 'Hewlett-Packard Industrial Printing Solutions Europe BVBA',
      description:
        'HQ: Diegem, Flemish Brabant | Belgium; Primary Industry: Technology Distributors',
    },
    {
      company: 'Hewlett-Packard International Pte. Ltd.',
      description:
        'HQ: Singapore | Singapore; Primary Industry: Technology Distributors',
    },
    {
      company: 'Hewlett-Packard Ireland (Holdings) Limited',
      description: 'HQ: Naas | Ireland',
    },
    {
      company: 'Hewlett-Packard Ireland 1 Ltd',
      description: 'HQ: Ireland',
    },
    {
      company: 'Hewlett-Packard Ise Gmbh',
      description: 'HQ: Germany',
    },
    {
      company: 'Hewlett-Packard Israel Ltd.',
      description:
        'HQ: Ra’anana | Israel; Primary Industry: Technology Distributors',
    },
    {
      company: 'Hewlett-Packard Japan Holding B.V.',
      description: 'HQ: Netherlands; Primary Industry: MultiSector Holdings',
    },
    {
      company: 'Imd, Technical Services B.V.',
      description:
        'HQ: Lelystad, Flevoland | Netherlands; Primary Industry: Office Services and Supplies',
    },
    {
      company: 'Hewlett-Packard Leiden B.V.',
      description: 'HQ: Netherlands',
    },
    {
      company: 'Hewlett-Packard Leman Sarl',
      description: 'HQ: Switzerland',
    },
    {
      company: 'Hewlett-Packard Luxembourg S.C.A.',
      description:
        'HQ: Capellen | Luxembourg; Primary Industry: Technology Distributors',
    },
    {
      company: 'Hewlett-Packard Madrid B.V.',
      description:
        'HQ: Amstelveen, Noord-Holland | Netherlands; Primary Industry: Asset Management and Custody Banks',
    },
    {
      company: 'Hewlett-Packard Malaysia Technology, Sdn. Bhd.',
      description:
        'HQ: Kuala Lumpur, Wilayah Persekutuan | Malaysia; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Hewlett-Packard Mercator B.v.',
      description: 'HQ: Netherlands',
    },
    {
      company: 'Hewlett-Packard Mergeco Vi, Llc',
      description:
        'HQ: Palo Alto, California | United States; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Hewlett-Packard Mergeco VI, LLC',
      description: 'HQ: Amsterdam, Noord-Holland | Netherlands',
    },
    {
      company: 'Hewlett-Packard Munich B.V.',
      description: 'HQ: Amstelveen, Noord-Holland | Netherlands',
    },
    {
      company: 'Hewlett-Packard Products B.V.',
      description:
        'HQ: Amstelveen, Noord-Holland | Netherlands; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Hewlett-Packard Products C.V',
      description:
        'HQ: Netherlands; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Hewlett-Packard Products CV 1, LLC',
      description: 'HQ: Palo Alto, California | United States',
    },
    {
      company: 'Hewlett-Packard Products CV 2, LLC',
      description: 'HQ: Palo Alto, California | United States',
    },
    {
      company: 'Hewlett-Packard Realisation',
      description: 'HQ: Les Ulis, Ile-de-France | France',
    },
    {
      company: 'Hewlett-Packard SA',
      description: 'HQ: Meyrin, Geneva | Switzerland',
    },
    {
      company: 'Hewlett-Packard Sverige Holding Ab',
      description: 'HQ: Sweden; Primary Industry: Thrifts and Mortgage Finance',
    },
    {
      company: 'Hewlett-Packard Singapore (Private) Limited',
      description:
        'HQ: Singapore | Singapore; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Hewlett-Packard Solutions Delivery Ltd.',
      description:
        'HQ: Japan; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'Hewlett-Packard South East Asia Pte Ltd.',
      description: 'HQ: Singapore',
    },
    {
      company: 'Hewlett-Packard Start B.V.',
      description: 'HQ: Amstelveen, Noord-Holland | Netherlands',
    },
    {
      company: 'Hewlett-Packard Trading SA',
      description: 'HQ: Dubai | United Arab Emirates',
    },
    {
      company: 'Hewlett-Packard Vision B.V.',
      description:
        'HQ: Amstelveen, Noord-Holland | Netherlands; Primary Industry: MultiSector Holdings',
    },
    {
      company: 'Hewlett-Packard World Trade, LLC',
      description: 'HQ: Palo Alto, California | United States',
    },
    {
      company: 'Hewlett-Packard World Trade Inc.',
      description: 'HQ: Amstelveen, Noord-Holland | Netherlands',
    },
    {
      company: 'Hewlett Packard Del Perú S.A.',
      description: 'HQ: Netherlands',
    },
    {
      company: 'Hewlett-Packard International Sales Corporation B V',
      description: 'HQ: Netherlands',
    },
    {
      company: 'HIFLEX GmbH',
      description:
        'HQ: Aachen, North Rhine-Westphalia | Germany; Primary Industry: Application Software',
    },
    {
      company: 'HIFLEX Corporation of North America',
      description:
        'HQ: Ashland, New York | United States; Primary Industry: Application Software',
    },
    {
      company: 'HP Austria GmbH',
      description: 'HQ: Vienna, Vienna | Austria',
    },
    {
      company: 'HP Belgium BVBA',
      description:
        'HQ: Diegem, Flemish Brabant | Belgium; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'HP Bilgisayar ve Baski Teknolojileri Limited Sirketi',
      description: 'HQ: Istanbul | Turkey',
    },
    {
      company:
        'HP Brasil Indústria e Comércio de Equipamentos Eletrônicos Ltda.',
      description: 'HQ: Barueri, São Paulo | Brazil',
    },
    {
      company: 'HP Canada Co.',
      description: 'HQ: Mississauga, Ontario | Canada',
    },
    {
      company: 'HP Colombia SAS',
      description: 'HQ: Bogota | Colombia',
    },
    {
      company: 'HP Computing and Printing d.o.o. (Zagreb)',
      description: 'HQ: Zagreb | Croatia',
    },
    {
      company: 'HP Computing and Printing Nigeria Ltd.',
      description: 'HQ: Nigeria',
    },
    {
      company: 'HP Computing and Printing Systems India Private Limited',
      description: 'HQ: Bengaluru, Karnataka | India',
    },
    {
      company: 'HP Deutschland GmbH',
      description:
        'HQ: Boeblingen, Baden-Württemberg | Germany; Primary Industry: Construction and Engineering',
    },
    {
      company: 'HP Facilities Services (Malaysia) Sdn. Bhd.',
      description: 'HQ: Malaysia',
    },
    {
      company: 'HP Financial Services (Japan) K.K.',
      description: 'HQ: Tokyo | Japan',
    },
    {
      company: 'HP Financial Services Gmbh',
      description: 'HQ: Austria',
    },
    {
      company: 'HP Finland Oy',
      description:
        'HQ: Espoo, Uusimaa | Finland; Primary Industry: Technology Distributors',
    },
    {
      company: 'HP Inc (Thailand) Ltd',
      description: 'HQ: Thailand',
    },
    {
      company: 'HP Inc (Thailand) Ltd.',
      description: 'HQ: Bangkok | Thailand',
    },
    {
      company: 'HP Inc Argentina S.R.L.',
      description: 'HQ: Buenos Aires, Buenos Aires | Argentina',
    },
    {
      company: 'HP Inc Bulgaria EOOD',
      description: 'HQ: Sofia | Bulgaria',
    },
    {
      company: 'HP Inc Chile Comercial Limitada',
      description: 'HQ: Santiago, Region Metropolitana (Santiago) | Chile',
    },
    {
      company: 'HP Inc Costa Rica, Limitada',
      description: 'HQ: San Jose | Costa Rica',
    },
    {
      company: 'HP Inc Czech Republic s.r.o.',
      description: 'HQ: Prague | Czech Republic',
    },
    {
      company: 'HP Inc Danmark ApS',
      description:
        'HQ: Allerød, Capital Region of Denmark | Denmark; Primary Industry: Technology Distributors',
    },
    {
      company: 'HP Inc Magyarorszag Kft.',
      description: 'HQ: Budapest | Hungary',
    },
    {
      company: 'HP Inc Polska sp. z o.o.',
      description: 'HQ: Warsaw | Poland',
    },
    {
      company: 'HP Inc Romania SRL',
      description: 'HQ: Bucharest | Romania',
    },
    {
      company: 'HP Inc Slovakia, s.r.o.',
      description: 'HQ: Bratislava | Slovakia',
    },
    {
      company: 'HP Inc UK Holding Limited',
      description: 'HQ: United Kingdom',
    },
    {
      company: 'HP Inc UK Limited',
      description:
        'HQ: Bracknell, Berkshire | United Kingdom; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Oneflow Systems Limited',
      description:
        'HQ: London, Greater London | United Kingdom; Primary Industry: Commercial Printing',
    },
    {
      company: 'HP India Pvt Ltd.',
      description:
        'HQ: Bangalore, Karnataka | India; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'HP Information Technology R & D (Shanghai) Co. Ltd.',
      description: 'HQ: Pudong, Shanghai Province | China',
    },
    {
      company: 'HP International Sàrl',
      description: 'HQ: Geneva, Geneva | Switzerland',
    },
    {
      company: 'HP Ireland Ltd.',
      description:
        'HQ: Leixlip, Co. Kildare | Ireland; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'HP Italy S.r.l.',
      description:
        'HQ: Milan, Milan | Italy; Primary Industry: Technology Distributors',
    },
    {
      company: 'HP Japan Inc.',
      description: 'HQ: Tokyo | Japan',
    },
    {
      company: 'HP Korea Inc.',
      description: 'HQ: Seoul | South Korea',
    },
    {
      company: 'HP Nederland B.V.',
      description:
        'HQ: Amstelveen, Noord-Holland | Netherlands; Primary Industry: Household Appliances',
    },
    {
      company: 'HP New Zealand',
      description: 'HQ: New Zealand',
    },
    {
      company: 'HP Norge AS',
      description:
        'HQ: Oslo, Oslo | Norway; Primary Industry: Technology Distributors',
    },
    {
      company: 'HP PPS Asia Pacific Pte. Ltd.',
      description: 'HQ: Singapore | Singapore',
    },
    {
      company: 'HP PPS Australia Pty Ltd',
      description: 'HQ: Forest Hill, Victoria | Australia',
    },
    {
      company: 'HP PPS Israel Ltd.',
      description: "HQ: Ra'anana | Israel",
    },
    {
      company: 'HP PPS Malaysia Sdn. Bhd.',
      description: 'HQ: Kuala Lumpur, Wilayah Persekutuan | Malaysia',
    },
    {
      company: 'HP PPS Philippines Inc.',
      description: 'HQ: Makati City | Philippines',
    },
    {
      company: 'HP PPS Sales Sdn. Bhd.',
      description: 'HQ: Kuala Lumpur, Wilayah Persekutuan | Malaysia',
    },
    {
      company: 'HP PPS Sverige AB',
      description:
        'HQ: Stockholm, Stockholm County | Sweden; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'HP Printing and Computing Solutions, S.L.U.',
      description: 'HQ: Barcelona, Catalonia | Spain',
    },
    {
      company: 'HP Printing and Personal Systems Hellas EPE',
      description: 'HQ: Athens | Greece',
    },
    {
      company: 'HP Printing Korea Co., Ltd',
      description: 'HQ: Suwon-si | South Korea',
    },
    {
      company: 'HP Schweiz GmbH',
      description: 'HQ: Dübendorf, Zurich | Switzerland',
    },
    {
      company: 'HP Services Saudi Arabia',
      description:
        'HQ: Riyadh | Saudi Arabia; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'HP Solutions Creation and Development Services S.L.U.',
      description: 'HQ: Las Rozas, Madrid | Spain',
    },
    {
      company: 'HP South Africa Proprietary Limited',
      description: 'HQ: Sandton, Gauteng | South Africa',
    },
    {
      company: 'HP Taiwan Information Technology Ltd.',
      description: 'HQ: Taipei | Taiwan',
    },
    {
      company: 'HP Technology (Beijing) Co., Ltd.',
      description: 'HQ: Beijing | China',
    },
    {
      company: 'HP Technology (Shanghai) Co. Ltd.',
      description:
        'HQ: Shanghai | China; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'HP Trading (Shanghai) Co. Ltd.',
      description:
        'HQ: Shanghai | China; Primary Industry: Technology Distributors',
    },
    {
      company: 'Hpcp - Computing And Printing Portugal, Unipessoal, Lda',
      description: 'HQ: Portugal',
    },
    {
      company: 'HPDirect Inc.',
      description:
        'HQ: Cupertino, California | United States; Primary Industry: Internet and Direct Marketing Retail',
    },
    {
      company: 'HPFS Global Holdings II, LLC',
      description: 'HQ: Murray Hill, New Jersey | United States',
    },
    {
      company: 'HPQ Holdings, LLC',
      description:
        'HQ: Houston, Texas | United States; Primary Industry: MultiSector Holdings',
    },
    {
      company: 'HPshopping.com',
      description:
        'HQ: Palo Alto, California | United States; Primary Industry: Internet and Direct Marketing Retail',
    },
    {
      company: 'Indigo America, Inc.',
      description:
        'HQ: Littleton, Massachusetts | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Kopiervertrieb Rhein-Ruhr GmbH',
      description:
        'HQ: Oberhausen, North Rhine-Westphalia | Germany; Primary Industry: Application Software',
    },
    {
      company: 'Limited Liability Company HP Inc',
      description: 'HQ: Moscow | Russia',
    },
    {
      company: 'MacDermid ColorSpan, Inc.',
      description:
        'HQ: Minnetonka, Minnesota | United States; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Melodeo, Inc.',
      description:
        'HQ: Seattle, Washington | United States; Primary Industry: Movies and Entertainment',
    },
    {
      company: 'Mercury Interactive (Europe) B.V.',
      description:
        'HQ: Amstelveen, Noord-Holland | Netherlands; Primary Industry: Technology Distributors',
    },
    {
      company: 'netfocus s.l.',
      description:
        'HQ: Barcelona, Catalonia | Spain; Primary Industry: Application Software',
    },
    {
      company: 'Nihon HP Nin-I Kumiai',
      description: 'HQ: Aguadilla, Puerto Rico | United States',
    },
    {
      company: 'Opsware Japan Co., Ltd.',
      description: 'HQ: Tokyo | Japan',
    },
    {
      company: 'P.F.E. Investments Ltd',
      description: 'HQ: Israel',
    },
    {
      company: 'Palm Asia Pacific Limited',
      description: 'HQ: Hong Kong',
    },
    {
      company: 'Palm Benelux B.V.',
      description: 'HQ: Netherlands',
    },
    {
      company: 'Palm Global Operations Ltd.',
      description: 'HQ: Ireland',
    },
    {
      company: 'Palm Ireland Investment',
      description: 'HQ: Ireland',
    },
    {
      company: 'Palm Trademark Holding Company, LLC',
      description: 'HQ: United States',
    },
    {
      company: 'Palm, Inc.',
      description:
        'HQ: Sunnyvale, California | United States; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Palm Australasia Pty Ltd.',
      description: 'HQ: Gordon, New South Wales | Australia',
    },
    {
      company: 'Palm Canada Inc.',
      description: 'HQ: Canada',
    },
    {
      company: 'Palm France SAS',
      description:
        'HQ: France; Primary Industry: Research and Consulting Services',
    },
    {
      company: 'Palm Geneva SARL',
      description: 'HQ: Switzerland',
    },
    {
      company: 'Palm Germany GmbH',
      description: 'HQ: Munchen | Germany',
    },
    {
      company: 'Palm Italy S.r.l.',
      description: 'HQ: Italy',
    },
    {
      company: 'Palm Singapore Pte. Ltd.',
      description: 'HQ: Singapore',
    },
    {
      company: 'Palm Singapore Sales Pte Ltd.',
      description: 'HQ: Singapore | Singapore',
    },
    {
      company: 'Peregrine Systems Global Ltd',
      description: 'HQ: Ireland',
    },
    {
      company: 'Peregrine Systems Operations Limited',
      description: 'HQ: Ireland',
    },
    {
      company: 'Performant Inc.',
      description:
        'HQ: The Colony, Texas | United States; Primary Industry: Construction and Engineering',
    },
    {
      company: 'PFC Acquisition Corp.',
      description:
        'HQ: Houston, Texas | United States; Primary Industry: Specialized Finance',
    },
    {
      company: 'Phoenix Holding L.P.',
      description: 'HQ: Bermuda',
    },
    {
      company: 'PrinterOn America Corporation',
      description:
        'HQ: Orland Park, Illinois | United States; Primary Industry: Distributors',
    },
    {
      company: 'PrinterOn Europe Limited',
      description: 'HQ: United States; Primary Industry: Distributors',
    },
    {
      company: 'PrinterOn Inc.',
      description:
        'HQ: Kitchener, Ontario | Canada; Primary Industry: Application Software',
    },
    {
      company: 'ProCurve Networking, Inc.',
      description:
        'HQ: Roseville, California | United States; Primary Industry: Communications Equipment',
    },
    {
      company: 'PT Compaq Computer Indonesia',
      description: 'HQ: Indonesia',
    },
    {
      company: 'PT Hewlett-Packard Berca Servisindo',
      description:
        'HQ: Jakarta, Jakarta Raya | Indonesia; Primary Industry: Technology Distributors',
    },
    {
      company: 'Pt Hewlett-packard Finance Indonesia',
      description: 'HQ: Indonesia',
    },
    {
      company: 'PT. Hewlett-Packard Indonesia',
      description:
        'HQ: Jakarta, Jakarta Raya | Indonesia; Primary Industry: Technology Distributors',
    },
    {
      company: 'Scitex Vision Hong Kong Limited',
      description: 'HQ: Hong Kong | Hong Kong',
    },
    {
      company: 'Simpress Comércio, Locação e Serviços S.A.',
      description:
        'HQ: São Paulo, São Paulo | Brazil; Primary Industry: Office Services and Supplies',
    },
    {
      company: 'S-Printing Solution Corp.',
      description:
        'HQ: China; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Synstar Business Continuity Limited',
      description:
        'HQ: Birmingham, West Midlands | United Kingdom; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'Tall Tree Insurance Company',
      description:
        'HQ: Burlington, Vermont | United States; Primary Industry: Property and Casualty Insurance',
    },
    {
      company: 'Tandem Computers India Limited',
      description: 'HQ: Palo Alto, California | United States',
    },
    {
      company: 'Technologies Et Participations',
      description: 'HQ: France',
    },
    {
      company: 'Twyngo Inc.',
      description:
        'HQ: Sunnyvale, California | United States; Primary Industry: Interactive Home Entertainment',
    },
    {
      company: 'Voodoo Computers Inc.',
      description:
        'HQ: Calgary, Alberta | Canada; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'WTAF, LLC',
      description: 'HQ: New Providence, New Jersey | United States',
    },
    {
      company: 'ZAO Hewlett-Packard AO',
      description:
        'HQ: Moscow | Russia; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Khyulett Pakkard Enterpraiz, Ooo',
      description:
        'HQ: Moscow | Russia; Primary Industry: IT Consulting and Other Services',
    },
  ],
  Xerox: [
    {
      company: 'ACS (Cyprus) Holdings Limited',
      description: 'HQ: Cyprus',
    },
    {
      company: 'Affiliated Computer Services of India Private Limited',
      description:
        'HQ: Bengaluru, Karnataka | India; Primary Industry: Data Processing and Outsourced Services',
    },
    {
      company: 'ACS Application Management Services, LLC',
      description:
        'HQ: Dallas, Texas | United States; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'Acs Bps Ltd.',
      description: 'HQ: United Kingdom',
    },
    {
      company: 'ACS BRC Holdings, Inc.',
      description:
        'HQ: Dallas, Texas | United States; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'The Pace Group, Inc.',
      description:
        'HQ: Dallas, Texas | United States; Primary Industry: Research and Consulting Services',
    },
    {
      company: 'ACS Business Services, LLC',
      description: 'HQ: United States',
    },
    {
      company: 'ACS Health Care, Inc.',
      description:
        'HQ: Dallas, Texas | United States; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'ACS Properties, LLC',
      description: 'HQ: United States',
    },
    {
      company: 'ACS Marketing, L.P.',
      description: 'HQ: United States',
    },
    {
      company: 'ACS Public Sector Solutions Inc.',
      description: 'HQ: Canada',
    },
    {
      company: 'ACS Business Process Solutions de Mexico S.A. de C.V.',
      description: 'HQ: Mexico',
    },
    {
      company: 'ACS Solutions de Mexico, S. de R.L. de C.V.',
      description: 'HQ: Mexico',
    },
    {
      company: 'Affiliated Computer Services Holdings (France) S.A.S.',
      description: 'HQ: France',
    },
    {
      company: 'Affiliated Computer Services Business Process Solutions S.A.S.',
      description: 'HQ: France; Primary Industry: Office Services and Supplies',
    },
    {
      company: 'Affiliated Computer Services Ireland Ltd.',
      description: 'HQ: Cork, Co. Cork | Ireland',
    },
    {
      company: 'Agilera, LLC',
      description:
        'HQ: Englewood, Colorado | United States; Primary Industry: Application Software',
    },
    {
      company: 'Altodigital Networks Ltd',
      description:
        'HQ: Bedfordshire, Bedfordshire | United Kingdom; Primary Industry: Office Services and Supplies',
    },
    {
      company: 'Altodigital UK Ltd.',
      description: 'HQ: Kingswinford, West Midlands | United Kingdom',
    },
    {
      company: 'Platinum Digital Print Solutions Limited',
      description:
        'HQ: Bedford, Bedfordshire | United Kingdom; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'American Photocopy Equipment Company of Pittsburgh, LLC',
      description:
        'HQ: Coraopolis, Pennsylvania | United States; Primary Industry: Distributors',
    },
    {
      company: 'AMTX Inc.',
      description: 'HQ: United States',
    },
    {
      company: 'Arizona Office Technologies, Inc.',
      description:
        'HQ: Phoenix, Arizona | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Arizona Office Technologies',
      description:
        'HQ: Tucson, Arizona | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Berney Office Solutions, LLC',
      description:
        'HQ: Montgomery, Alabama | United States; Primary Industry: Commercial Printing',
    },
    {
      company: 'Modern Business Machines, LLC',
      description:
        'HQ: Pelham, Alabama | United States; Primary Industry: Computer and Electronics Retail',
    },
    {
      company: 'Bessemer Insurance Limited',
      description: 'HQ: Pembroke | Bermuda',
    },
    {
      company: 'Better Quality Business Systems, Inc.',
      description:
        'HQ: New Albany, Indiana | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Blackstone Valley Office Systems, Co., Inc.',
      description:
        'HQ: Lincoln, Rhode Island | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Boise Office Equipment, Inc.',
      description:
        'HQ: Boise, Idaho | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Bradley Company, Inc.',
      description:
        'HQ: Cleveland, Ohio | United States; Primary Industry: Application Software',
    },
    {
      company: 'Buck Consultants, S.L.',
      description: 'HQ: Madrid, Madrid | Spain',
    },
    {
      company: 'Business Equipment Unlimited',
      description:
        'HQ: Portland, Maine | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Capital Business Systems, Inc.',
      description: 'HQ: Harrisburg, Pennsylvania | United States',
    },
    {
      company: 'Capitol Office Solutions, LLC',
      description:
        'HQ: Columbia, Maryland | United States; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'Office Tech, Inc.',
      description:
        'HQ: Bellmawr, New Jersey | United States; Primary Industry: Distributors',
    },
    {
      company: 'Carolina Office Systems, Inc.',
      description:
        'HQ: Huntersville, North Carolina | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Carr Business Systems, Inc.',
      description:
        'HQ: Melville, New York | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Centre Business Products, Inc.',
      description: 'HQ: United States',
    },
    {
      company: 'Chicago Office Technology Group, Inc.',
      description:
        'HQ: Bolingbrook, Illinois | United States; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'Image Manufacturing, Inc.',
      description:
        'HQ: Bolingbrook, Illinois | United States; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'ComDoc, Inc.',
      description:
        'HQ: Uniontown, Ohio | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Conestoga Business Solutions, Inc.',
      description:
        'HQ: Lancaster, Pennsylvania | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Connecticut Business Systems, LLC',
      description:
        'HQ: Newington, Connecticut | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Conway Office Solutions, Inc.',
      description:
        'HQ: Nashua, New Hampshire | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Copy Dynamics, Inc.',
      description:
        'HQ: Jamesburg, New Jersey | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'CopyCo Office Solutions, Inc.',
      description:
        'HQ: Indianapolis, Indiana | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Ctx Business Solutions, Inc.',
      description: 'HQ: United States',
    },
    {
      company: 'Dahill Office Technology Corporation',
      description:
        'HQ: San Antonio, Texas | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Alternative Office Systems, Inc.',
      description:
        'HQ: Grapevine, Texas | United States; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Denitech Corporation',
      description:
        'HQ: Coppell, Texas | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Dallas Denitech Limited',
      description: 'HQ: United States; Primary Industry: Distributors',
    },
    {
      company: 'Denitech Holdings Llc',
      description: 'HQ: United States',
    },
    {
      company: 'Denitech Partners Llc',
      description: 'HQ: United States',
    },
    {
      company: 'Digitex Canada Inc.',
      description:
        'HQ: Red Deer, Alberta | Canada; Primary Industry: Office Services and Supplies',
    },
    {
      company: 'Eastern Copy Products LLC',
      description:
        'HQ: Syracuse, New York | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Entre Computer Centers, Inc.',
      description:
        'HQ: Oklahoma City, Oklahoma | United States; Primary Industry: Computer and Electronics Retail',
    },
    {
      company: 'eServices Group (St. Lucia) Limited',
      description: 'HQ: Saint Vincent & Grenadines',
    },
    {
      company: 'e-Services Group International (Jamaica) Limited',
      description: 'HQ: Jamaica',
    },
    {
      company: 'FairCopy Services Inc.',
      description: 'HQ: Canada',
    },
    {
      company: 'Fourth Xerox Receivables, LLC',
      description: 'HQ: Delaware | United States',
    },
    {
      company: 'Georgia Duplicating Products, Inc.',
      description:
        'HQ: Macon, Georgia | United States; Primary Industry: Internet Services and Infrastructure',
    },
    {
      company: 'G-Five, Inc.',
      description:
        'HQ: Greenville, South Carolina | United States; Primary Industry: Office Services and Supplies',
    },
    {
      company: 'Global Imaging Finance Company, LLC',
      description: 'HQ: Tampa, Florida | United States',
    },
    {
      company: 'Global Imaging Operations, LLC',
      description: 'HQ: Tampa, Florida | United States',
    },
    {
      company: 'Green Imaging Supplies Inc',
      description: 'HQ: Canada',
    },
    {
      company: 'GroupFire, Inc.',
      description:
        'HQ: Redwood City, California | United States; Primary Industry: Application Software',
    },
    {
      company: 'Gyricon LLC',
      description:
        'HQ: Ann Arbor, Michigan | United States; Primary Industry: Electronic Components',
    },
    {
      company: 'Hugh Symons Wireless Data Services Pty. Ltd.',
      description:
        'HQ: Wollongong, New South Wales | Australia; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'Image Technology Specialists, Inc.',
      description:
        'HQ: Canton, Massachusetts | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Imagetek Office Systems, L.P.',
      description:
        'HQ: Arlington, Texas | United States; Primary Industry: Commercial Printing',
    },
    {
      company: 'Imagine Technology Group, Inc.',
      description:
        'HQ: Chicago, Illinois | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'El Paso Triad',
      description: 'HQ: United States',
    },
    {
      company: 'Imaging Concepts of New Mexico, Inc.',
      description:
        'HQ: Albuquerque, New Mexico | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Impika SAS',
      description:
        "HQ: Aubagne, Provence-Alpes-Côte d'Azur | France; Primary Industry: Technology Hardware, Storage and Peripherals",
    },
    {
      company: 'Inland Business Machines, Inc.',
      description:
        'HQ: Sacramento, California | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Institute for Research on Learning',
      description:
        'HQ: United States; Primary Industry: Diversified Support Services',
    },
    {
      company: 'Intellinet, Ltd.',
      description: 'HQ: Stamford, Connecticut | United States',
    },
    {
      company: 'Irish Business Systems Ltd',
      description:
        'HQ: Dublin, Co. Dublin | Ireland; Primary Industry: Commercial Printing',
    },
    {
      company: 'LaserNetworks Inc.',
      description:
        'HQ: Oakville, Ontario | Canada; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'Lasernetworks Inc.',
      description: 'HQ: Morrisville, North Carolina | United States',
    },
    {
      company: 'Lewan & Associates, Inc.',
      description:
        'HQ: Denver, Colorado | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'LiveWire, LLC',
      description:
        'HQ: Saint Louis, Missouri | United States; Primary Industry: Application Software',
    },
    {
      company: 'Low-Complexity Manufacturing Group Inc.',
      description: 'HQ: Webster, New York | United States',
    },
    {
      company: 'Martin Whalen Office Solutions, Inc.',
      description:
        'HQ: Bradley, Illinois | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Michigan Office Solutions, Inc.',
      description:
        'HQ: Grand Rapids, Michigan | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Minnesota Office Technology Group, Inc.',
      description:
        'HQ: Bolingbrook, Illinois | United States; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Modern High Tech Web SA',
      description:
        'HQ: Rio de Janeiro, Rio de Janeiro | Brazil; Primary Industry: Interactive Home Entertainment',
    },
    {
      company: 'MT Business Technologies, Inc.',
      description:
        'HQ: Mansfield, Ohio | United States; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'MWB Copy Products, Inc.',
      description: 'HQ: United States; Primary Industry: Specialty Stores',
    },
    {
      company: 'N & L Enterprises LLC',
      description:
        'HQ: Huntsville, Alabama | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'N.V. Xerox S.A.',
      description: 'HQ: Belgium',
    },
    {
      company: 'Nuvisio Corporation',
      description:
        'HQ: New York, New York | United States; Primary Industry: Application Software',
    },
    {
      company: 'NV Xerox Credit S.A.',
      description:
        'HQ: Belgium; Primary Industry: Computer and Electronics Retail',
    },
    {
      company: 'OEM SupplyCo, Inc.',
      description:
        'HQ: Uniontown, Ohio | United States; Primary Industry: Distributors',
    },
    {
      company: 'Office Products, Inc./Cleveland',
      description: 'HQ: United States',
    },
    {
      company: 'Oita Xerox Corporation',
      description: 'HQ: Japan',
    },
    {
      company: 'OneSource Managed Services',
      description:
        'HQ: Oklahoma City, Oklahoma | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Pacific Service & Development Inc',
      description: 'HQ: Lihue, Hawaii | United States',
    },
    {
      company: 'Palo Alto Research Center Incorporated',
      description:
        'HQ: Palo Alto, California | United States; Primary Industry: Research and Consulting Services',
    },
    {
      company: 'Patient Accounting Service Center, L.L.C.',
      description:
        'HQ: Kent, Washington | United States; Primary Industry: Research and Consulting Services',
    },
    {
      company: 'Pinnell, Inc.',
      description:
        'HQ: Kennewick, Washington | United States; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Precision Copier Service, Inc.',
      description:
        'HQ: Doral, Florida | United States; Primary Industry: Office Services and Supplies',
    },
    {
      company: 'ProView, Inc.',
      description: 'HQ: Tampa, Florida | United States',
    },
    {
      company: 'Quality Business Systems Inc.',
      description:
        'HQ: Bellevue, Washington | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Restaurant Technology Services, LLC',
      description:
        'HQ: Oak Brook, Illinois | United States; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'Ridge Reinsurance Ltd.',
      description: 'HQ: Bermuda',
    },
    {
      company: 'RK Dixon Company',
      description:
        'HQ: Davenport, Iowa | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'RNTS, Inc.',
      description: 'HQ: Stamford, Connecticut | United States',
    },
    {
      company: 'RRXIL Limited',
      description: 'HQ: United Kingdom; Primary Industry: MultiSector Holdings',
    },
    {
      company: 'Saudi Xerox Limited',
      description:
        'HQ: Riyadh | Saudi Arabia; Primary Industry: Technology Distributors',
    },
    {
      company: 'Set Electronique SA',
      description:
        'HQ: France; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Sidh Securities Limited',
      description: 'HQ: Mauritius',
    },
    {
      company: 'Tec Document Solutions Inc',
      description: 'HQ: United States',
    },
    {
      company: 'The Xerox Foundation',
      description:
        'HQ: United States; Primary Industry: Diversified Support Services',
    },
    {
      company: 'TML Enterprises, Inc.',
      description:
        'HQ: Manassas, Virginia | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Veenman B.V.',
      description:
        'HQ: Capelle aan den IJssel, Zuid-Holland | Netherlands; Primary Industry: Distributors',
    },
    {
      company: 'X.System Services Gmbh',
      description: 'HQ: Austria',
    },
    {
      company: 'Xc Global Trading B.V.',
      description:
        'HQ: Venray, Limburg | Netherlands; Primary Industry: MultiSector Holdings',
    },
    {
      company: 'XC Trading Singapore Pte. Ltd.',
      description:
        'HQ: Singapore | Singapore; Primary Industry: Data Processing and Outsourced Services',
    },
    {
      company: 'Xceed Financial Credit Union',
      description:
        'HQ: El Segundo, California | United States; Primary Industry: Regional Banks',
    },
    {
      company: 'Xerobail SAS',
      description:
        'HQ: France; Primary Industry: Trading Companies and Distributors',
    },
    {
      company: 'Xerographic Solutions, Inc.',
      description:
        'HQ: Plymouth, Michigan | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'XEROX (Belgique) S.A.',
      description:
        'HQ: Zaventem, Flemish Brabant | Belgium; Primary Industry: Distributors',
    },
    {
      company: 'Xerox (Ireland) Limited',
      description:
        'HQ: Blanchardstown | Ireland; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Xerox ( Europe) Limited - Sucursal Em Portugal',
      description: 'HQ: Portugal',
    },
    {
      company: 'Xerox (Nederland) BV',
      description: 'HQ: Breukelen, Utrecht | Netherlands',
    },
    {
      company: 'Xerox A/S',
      description:
        'HQ: Ballerup | Denmark; Primary Industry: Technology Distributors',
    },
    {
      company: 'Xerox AB',
      description: 'HQ: Sweden; Primary Industry: Office Services and Supplies',
    },
    {
      company: 'Xerox AG',
      description:
        'HQ: Glattbrugg, Zurich | Switzerland; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Xerox Argentina Industrial y Comercial S.A.',
      description: 'HQ: Argentina',
    },
    {
      company: 'Xerox AS',
      description:
        'HQ: Lysaker, Akershus | Norway; Primary Industry: Trading Companies and Distributors',
    },
    {
      company: 'Xerox Bulgaria EOOD',
      description: 'HQ: Sofia | Bulgaria',
    },
    {
      company: 'Xerox Business Centre (Ireland) Limited',
      description: 'HQ: Ireland',
    },
    {
      company: 'Xerox Business Services (Switzerland) AG',
      description:
        'HQ: Bern, Bern | Switzerland; Primary Industry: Electronic Equipment and Instruments',
    },
    {
      company: 'Xerox Business Solutions, Inc.',
      description:
        'HQ: Tampa, Florida | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Copytronix',
      description:
        'HQ: Portland, Oregon | United States; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Denitech Fort Worth, Inc.',
      description: 'HQ: United States',
    },
    {
      company: 'Denitech Fort Worth Holdings Llc',
      description: 'HQ: United States',
    },
    {
      company: 'Denitech Fort Worth Partners Llc',
      description: 'HQ: United States',
    },
    {
      company: 'Dfw Denitech Limited',
      description: 'HQ: United States',
    },
    {
      company: 'Digitec Business Systems, Inc.',
      description: 'HQ: United States',
    },
    {
      company: 'élan Marketing, Inc.',
      description:
        'HQ: Las Vegas, Nevada | United States; Primary Industry: Office Services and Supplies',
    },
    {
      company: 'Electronic Systems, Inc.',
      description:
        'HQ: Sioux Falls, South Dakota | United States; Primary Industry: Electronic Manufacturing Services',
    },
    {
      company: 'Electronic Systems, Inc.',
      description:
        'HQ: Virginia Beach, Virginia | United States; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'Electronic Systems Of Richmond Inc.',
      description: 'HQ: Tampa, Florida | United States',
    },
    {
      company: 'McKendree Imaging Systems & Solutions',
      description:
        'HQ: Norfolk, Virginia | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'imageQUEST, Inc.',
      description:
        'HQ: Wichita, Kansas | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Laser Resources Inc.',
      description:
        'HQ: Urbandale, Iowa | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Lucas Business Systems, Inc.',
      description:
        'HQ: Modesto, California | United States; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Mr. Copy, Inc.',
      description:
        'HQ: San Diego, California | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'MRC Smart Technology Solutions, Inc.',
      description:
        'HQ: San Diego, California | United States; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Rabbit Office Automation',
      description:
        'HQ: Sunnyvale, California | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Northeast Copier Systems, LLC',
      description:
        'HQ: Milford, Massachusetts | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Pacific Office Solutions, Inc.',
      description:
        'HQ: Rancho Santa Margarita, California | United States; Primary Industry: Distributors',
    },
    {
      company: 'Premier Office Equipment, Inc.',
      description:
        'HQ: Marshalltown, Iowa | United States; Primary Industry: Office Services and Supplies',
    },
    {
      company: 'Saxon Business Systems, Inc.',
      description:
        'HQ: Miami Lakes, Florida | United States; Primary Industry: Office Services and Supplies',
    },
    {
      company: 'SoCal Office Technologies, Inc.',
      description:
        'HQ: Cypress, California | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Stewart Business Systems, LLC',
      description:
        'HQ: Burlington, New Jersey | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Heritage Business Systems, Inc.',
      description:
        'HQ: Moorestown, New Jersey | United States; Primary Industry: Office Services and Supplies',
    },
    {
      company: 'Stewart of Alabama, Inc.',
      description:
        'HQ: Birmingham, Alabama | United States; Primary Industry: Commercial Printing',
    },
    {
      company: 'Tejas Business Systems, Inc.',
      description: 'HQ: United States',
    },
    {
      company: 'Tbs Denitech Limited',
      description: 'HQ: United States',
    },
    {
      company: 'Tejas Partners Llc',
      description: 'HQ: United States',
    },
    {
      company: 'Tejas Systems Holdings Llc',
      description: 'HQ: United States',
    },
    {
      company: 'Transco Business Technologies',
      description:
        'HQ: Augusta, Maine | United States; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Xerographic Solutions, Inc.',
      description:
        'HQ: Fairport, New York | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Zeno Office Solutions, Inc.',
      description:
        'HQ: Tampa, Florida | United States; Primary Industry: Technology Distributors',
    },
    {
      company: 'Xerox Canada Capital Ltd.',
      description: 'HQ: Toronto, Ontario | Canada',
    },
    {
      company: 'Xerox Canada Inc.',
      description:
        'HQ: North York, Ontario | Canada; Primary Industry: Office Services and Supplies',
    },
    {
      company: 'Xerox Canada Leasing Partnership',
      description: 'HQ: Canada',
    },
    {
      company: 'Xerox Research Centre of Canada',
      description: 'HQ: Mississauga, Ontario | Canada',
    },
    {
      company: 'Xerox Canada Ltd.',
      description:
        'HQ: Toronto, Ontario | Canada; Primary Industry: Distributors',
    },
    {
      company: 'Ionographic Operations Partnership',
      description: 'HQ: Canada',
    },
    {
      company: 'Xerox Capital De Mexico, S.A. De C.V.',
      description:
        'HQ: Mexico; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Xerox Capital LLC',
      description:
        'HQ: Stamford, Connecticut | United States; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Xerox Capital Services LLC',
      description:
        'HQ: Rochester, New York | United States; Primary Industry: Specialized Finance',
    },
    {
      company: 'Xerox Capital Trust I',
      description:
        'HQ: Stamford, Connecticut | United States; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Xerox Capital Trust II',
      description:
        'HQ: Connecticut | United States; Primary Industry: Data Processing and Outsourced Services',
    },
    {
      company: 'Xerox Colografx Systems, Inc.',
      description:
        'HQ: San Jose, California | United States; Primary Industry: Commercial Printing',
    },
    {
      company: 'Xerox Corporation',
      description:
        'HQ: Norwalk, Connecticut | United States; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Xerox Buro Araciari Ticaret ve Servis A.S.',
      description:
        'HQ: Istanbul | Turkey; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Xerox de Chile S.A.',
      description: 'HQ: Huechuraba, Region Metropolitana (Santiago) | Chile',
    },
    {
      company: 'Xerox de Colombia S.A.',
      description: 'HQ: Bogotá | Colombia',
    },
    {
      company: 'Xerox de Nicaragua, S.A.',
      description: 'HQ: Nicaragua',
    },
    {
      company: 'Xerox de Venezuela C.A.',
      description: 'HQ: Caracas, Miranda | Venezuela',
    },
    {
      company: 'Xerox del Ecuador S.A.',
      description:
        'HQ: Quito | Ecuador; Primary Industry: Technology Distributors',
    },
    {
      company: 'Xerox del Peru S.A.',
      description: 'HQ: Lima, Lima | Peru',
    },
    {
      company: 'Xerox Developing Markets Limited',
      description: 'HQ: Bermuda',
    },
    {
      company: 'Xerox Distributor Group',
      description: 'HQ: United States',
    },
    {
      company: 'Xerox Do Brasil Ltda.',
      description: 'HQ: Brazil',
    },
    {
      company: 'Xerox Document Supplies BV',
      description:
        'HQ: Breukelen, Utrecht | Netherlands; Primary Industry: Distributors',
    },
    {
      company: 'Xerox Egypt S.A.E',
      description:
        'HQ: Cairo | Egypt; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Xerox Electronic (Ireland) Limited',
      description: 'HQ: Dublin | Ireland',
    },
    {
      company: 'Xerox Finance AG',
      description:
        'HQ: Glattbrugg, Zurich | Switzerland; Primary Industry: Specialized Finance',
    },
    {
      company: 'Xerox Finance Inc.',
      description:
        'HQ: Stamford, Connecticut | United States; Primary Industry: Consumer Finance',
    },
    {
      company: 'Xerox Finance Leasing S.A.E.',
      description: 'HQ: Egypt',
    },
    {
      company: 'Xerox Finance NV',
      description: 'HQ: United States',
    },
    {
      company: 'Xerox Financial Services B.V.',
      description:
        'HQ: Breukelen, Utrecht | Netherlands; Primary Industry: Specialized Finance',
    },
    {
      company: 'Xerox Financial Services Belux NV',
      description: 'HQ: Belgium',
    },
    {
      company: 'Xerox Financial Services Danmark A/S',
      description: 'HQ: Ballerup | Denmark',
    },
    {
      company: 'Xerox Financial Services Finland Oy',
      description: 'HQ: Espoo | Finland',
    },
    {
      company: 'Xerox Financial Services SAS',
      description:
        'HQ: Neuilly-sur-Seine, Ile-de-France | France; Primary Industry: Trading Companies and Distributors',
    },
    {
      company: 'Xerox Financial Services, LLC',
      description:
        'HQ: Stamford, Connecticut | United States; Primary Industry: Property and Casualty Insurance',
    },
    {
      company: 'Xerox Finans',
      description: 'HQ: Denmark',
    },
    {
      company: 'Xerox France',
      description:
        'HQ: Paris, Ile-de-France | France; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Xerox Document Services SNC',
      description: 'HQ: France',
    },
    {
      company: 'Xerox Document Supplies SNC',
      description: 'HQ: France; Primary Industry: Distributors',
    },
    {
      company: 'Xerox Funding Corp.',
      description: 'HQ: Connecticut | United States',
    },
    {
      company: 'Xerox Funding LLC II',
      description: 'HQ: United States',
    },
    {
      company: 'Xerox General Services SAS',
      description:
        'HQ: Paris, Ile-de-France | France; Primary Industry: Office Services and Supplies',
    },
    {
      company: 'Xerox Global Services Limited',
      description: 'HQ: United Kingdom',
    },
    {
      company: 'Xerox Global Services SAS',
      description:
        'HQ: Villeneuve Dascq, Nord-Pas-de-Calais | France; Primary Industry: Internet Services and Infrastructure',
    },
    {
      company: 'Xerox Global Services, Inc.',
      description:
        'HQ: Rochester, New York | United States; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'Xerox GmbH',
      description:
        'HQ: Neuss, North Rhine-Westphalia | Germany; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Xerox Holding (Nederland) B.V.',
      description:
        'HQ: Venray, Limburg | Netherlands; Primary Industry: MultiSector Holdings',
    },
    {
      company: 'Xerox Holding LLC',
      description: 'HQ: Connecticut | United States',
    },
    {
      company: 'Xerox Imaging Systems Inc.',
      description: 'HQ: Stamford, Connecticut | United States',
    },
    {
      company: 'Xerox India Limited',
      description:
        'HQ: Gurugram, Haryana | India; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Xerox International Joint Marketing Incorporated',
      description: 'HQ: Stamford, Connecticut | United States',
    },
    {
      company: 'Xerox Investments Europe B.V.',
      description:
        'HQ: Breukelen, Utrecht | Netherlands; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'RRXH Limited',
      description: 'HQ: United Kingdom',
    },
    {
      company: 'RRXO Limited',
      description: 'HQ: United Kingdom',
    },
    {
      company: 'Xerox Equipment UK Limited',
      description: 'HQ: United Kingdom',
    },
    {
      company: 'Xerox Holdings (Ireland) Limited',
      description: 'HQ: Dublin, Co. Dublin | Ireland',
    },
    {
      company: 'Xerox Products Uk Limited',
      description:
        'HQ: United Kingdom; Primary Industry: Technology Distributors',
    },
    {
      company: 'Xerox UK Holdings Limited',
      description: 'HQ: United Kingdom; Primary Industry: MultiSector Holdings',
    },
    {
      company: 'Triton Business Finance Limited',
      description: 'HQ: Uxbridge, Greater London | United Kingdom',
    },
    {
      company: 'Xerox (Ireland) Limited',
      description:
        'HQ: Blanchardstown | Ireland; Primary Industry: Data Processing and Outsourced Services',
    },
    {
      company: 'Xerox (Romania) Echipmante Si Servici S.A.',
      description: 'HQ: Bucuresti | Romania',
    },
    {
      company: 'Xerox Hellas AEE',
      description:
        'HQ: Athens | Greece; Primary Industry: Technology Distributors',
    },
    {
      company: 'Xerox Overseas Holdings Limited',
      description:
        'HQ: Buckingham, Buckinghamshire | United Kingdom; Primary Industry: MultiSector Holdings',
    },
    {
      company: 'Xerox Business Equipment Limited',
      description: 'HQ: Uxbridge, Greater London | United Kingdom',
    },
    {
      company: 'Xerox Computer Services Limited',
      description: 'HQ: Uxbridge, Greater London | United Kingdom',
    },
    {
      company: 'XRO Limited',
      description: 'HQ: United Kingdom',
    },
    {
      company: 'Nemo (AKS) Limited',
      description: 'HQ: United Kingdom',
    },
    {
      company: 'Xerox Trading Enterprises Limited',
      description: 'HQ: Uxbridge, Greater London | United Kingdom',
    },
    {
      company: 'XRI Limited',
      description: 'HQ: United Kingdom',
    },
    {
      company: 'Xerox Israel Ltd.',
      description: 'HQ: Lod | Israel; Primary Industry: Distributors',
    },
    {
      company: 'Xerox Kazakhstan Limited Liability Partnership',
      description: 'HQ: Kazakhstan',
    },
    {
      company: 'Xerox Latinamerican Holdings Inc.',
      description: 'HQ: Stamford, Connecticut | United States',
    },
    {
      company: 'Xerox Lease Funding LLC',
      description: 'HQ: United States',
    },
    {
      company: 'Xerox Leasing Deutschland GmbH',
      description:
        'HQ: Neuss, North Rhine-Westphalia | Germany; Primary Industry: Trading Companies and Distributors',
    },
    {
      company: 'Xerox Leasing Gmbh',
      description: 'HQ: Austria; Primary Industry: Specialized Finance',
    },
    {
      company: 'Xerox Limited',
      description:
        'HQ: Uxbridge, Middlesex | United Kingdom; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Continua Limited',
      description:
        'HQ: Luton, Bedfordshire | United Kingdom; Primary Industry: Diversified Support Services',
    },
    {
      company: 'Continua Sanctum Limited',
      description: 'HQ: United Kingdom',
    },
    {
      company: 'Creditex - Aluguer De Equipamentos, S.A.',
      description: 'HQ: Portugal',
    },
    {
      company: 'Newfield Information Technology Limited',
      description: 'HQ: Uxbridge, Greater London | United Kingdom',
    },
    {
      company: 'NewField IT Ltd',
      description:
        'HQ: Twickenham, Greater London | United Kingdom; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'Rank Xerox Finance (Nederland) BV',
      description: 'HQ: Netherlands',
    },
    {
      company: 'Rank Xerox Limited (Malaysia)',
      description: 'HQ: Malaysia',
    },
    {
      company: 'The Xerox (UK) Trust',
      description: 'HQ: United Kingdom; Primary Industry: MultiSector Holdings',
    },
    {
      company: 'Xerox (Barbados) SRL',
      description: 'HQ: Barbados',
    },
    {
      company: 'Xerox (Ukraine) Ltd. LLC',
      description:
        'HQ: Kyiv | Ukraine; Primary Industry: Technology Distributors',
    },
    {
      company: 'Xerox Austria Gmbh',
      description:
        'HQ: Vienna, Vienna | Austria; Primary Industry: Technology Distributors',
    },
    {
      company: 'Xerox Capital (Europe) Limited',
      description:
        'HQ: Uxbridge, Middlesex | United Kingdom; Primary Industry: Asset Management and Custody Banks',
    },
    {
      company: 'Concept Group Ltd.',
      description:
        'HQ: Livingston, West Lothian | United Kingdom; Primary Industry: Technology Distributors',
    },
    {
      company: 'Imaging Business Systems (N.I.) Ltd',
      description:
        'HQ: United Kingdom; Primary Industry: Office Services and Supplies',
    },
    {
      company: 'Xerox (UK) Limited',
      description:
        'HQ: Uxbridge, Greater London | United Kingdom; Primary Industry: Technology Distributors',
    },
    {
      company: 'Xerox Finance Limited',
      description:
        'HQ: Uxbridge, Middlesex | United Kingdom; Primary Industry: Trading Companies and Distributors',
    },
    {
      company: 'Xerox Channels Ltd',
      description: 'HQ: United Kingdom',
    },
    {
      company: 'Xerox Comércio e Indústria Ltda.',
      description:
        'HQ: Rio De Janeiro, Rio de Janeiro | Brazil; Primary Industry: Industrial Machinery',
    },
    {
      company: 'XEROX CZECH REPUBLIC s.r.o.',
      description:
        'HQ: Prague | Czech Republic; Primary Industry: Technology Distributors',
    },
    {
      company: 'Xerox Dienstleistungsges. Mbh',
      description: 'HQ: Neuss | Germany',
    },
    {
      company: 'Xerox Emirates LLC',
      description:
        'HQ: United Arab Emirates; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Xerox España S.A.U.',
      description:
        'HQ: Madrid, Madrid | Spain; Primary Industry: Office Services and Supplies',
    },
    {
      company: 'Xerox Global Services Gmbh',
      description: 'HQ: Vienna, Vienna | Austria',
    },
    {
      company: 'Xerox Italia Rental Services S.r.l.',
      description:
        'HQ: Italy; Primary Industry: Trading Companies and Distributors',
    },
    {
      company: 'Xerox Luxembourg S.A.',
      description:
        'HQ: Bertrange | Luxembourg; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'Xerox Polska Sp.zo.o',
      description: 'HQ: Warsaw | Poland',
    },
    {
      company: 'Xerox Portugal Equipamentos de Escritorio Limitada',
      description: 'HQ: Portugal; Primary Industry: Distributors',
    },
    {
      company: 'Xerox Professional Services Limited',
      description:
        'HQ: Uxbridge, Middlesex | United Kingdom; Primary Industry: Office Services and Supplies',
    },
    {
      company: 'Xerox Serviços e Participações Ltda.',
      description:
        'HQ: Rio de Janeiro, Rio de Janeiro | Brazil; Primary Industry: Technology Distributors',
    },
    {
      company: 'Xerox Slovenia d.o.o.',
      description: 'HQ: Ljubljana | Slovenia',
    },
    {
      company: 'Xerox Limited, Organizacna Zlozka Podniku Zahranicnej Osoby',
      description: 'HQ: Bratislava | Slovakia',
    },
    {
      company: 'Xerox Litigation Services Inc.',
      description:
        'HQ: Albany, New York | United States; Primary Industry: Application Software',
    },
    {
      company: 'Xerox Ltd and Xerox (C.I.S) LLP',
      description: 'HQ: Moscow | Russia',
    },
    {
      company: 'XEROX Magyarország Kereskedelmi Kft',
      description:
        'HQ: Budapest | Hungary; Primary Industry: Office Services and Supplies',
    },
    {
      company: 'Xerox Manufacturing (Nederland) B.V.',
      description:
        'HQ: Netherlands; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Xerox Maroc S.A.',
      description:
        'HQ: Morocco; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Xerox Mexicana S.A. de C.V.',
      description:
        'HQ: Mexico city, Distrito Federal | Mexico; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Xerox Middle East Investments (Bermuda) Limited',
      description: 'HQ: Bermuda',
    },
    {
      company: 'Xerox Office Group',
      description:
        'HQ: Wilsonville, Oregon | United States; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Xerox Office Printing Distribution B.V.',
      description: 'HQ: Venray, Limburg | Netherlands',
    },
    {
      company: 'Xerox Office Supplies AG',
      description:
        'HQ: Bachenblach, Zurich | Switzerland; Primary Industry: Technology Distributors',
    },
    {
      company: 'Xerox Office Supplies GmbH',
      description: 'HQ: Vienna, Vienna | Austria',
    },
    {
      company: 'Xerox Office Supplies Limited',
      description: 'HQ: United Kingdom',
    },
    {
      company: 'Xerox Overseas, Inc',
      description: 'HQ: United States',
    },
    {
      company: 'Xerox Oy',
      description:
        'HQ: Espoo, Uusimaa | Finland; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Xerox Products Limited',
      description: 'HQ: Bermuda',
    },
    {
      company: 'Xerox Real Estate Services Inc',
      description: 'HQ: Stamford, Connecticut | United States',
    },
    {
      company: 'Xerox Realty Corporation',
      description: 'HQ: United States',
    },
    {
      company: 'Xerox Rentalease BV',
      description: 'HQ: Netherlands',
    },
    {
      company: 'Xerox Renting S.A.U.',
      description: 'HQ: Spain',
    },
    {
      company: 'Xerox Reprographische Services GmbH',
      description: 'HQ: Germany',
    },
    {
      company: 'XEROX S.A.S.',
      description: 'HQ: Paris, Ile-de-France | France',
    },
    {
      company: '*Xerox Document Services SNC',
      description: 'HQ: France',
    },
    {
      company: '*Xerox Document Supplies SNC',
      description: 'HQ: France; Primary Industry: Distributors',
    },
    {
      company: 'Xerox S.p.A.',
      description:
        'HQ: Sesto San Giovanni, Milan | Italy; Primary Industry: Technology Hardware, Storage and Peripherals',
    },
    {
      company: 'Xerox Services BV',
      description:
        'HQ: Breukelen, Utrecht | Netherlands; Primary Industry: Diversified Support Services',
    },
    {
      company: 'Xerox Servicios Compartidos Guatemala',
      description: 'HQ: Guatemala',
    },
    {
      company: 'Xerox Shared Services Romania SRL',
      description: 'HQ: Romania',
    },
    {
      company: 'Xerox Sverige AB',
      description:
        'HQ: Kista, Stockholm County | Sweden; Primary Industry: Distributors',
    },
    {
      company: 'Xerox Technology Enterprises',
      description:
        'HQ: Stamford, Connecticut | United States; Primary Industry: Research and Consulting Services',
    },
    {
      company: 'Xerox Telebusiness GmbH',
      description: 'HQ: Neuss, North Rhine-Westphalia | Germany',
    },
    {
      company: 'Xerox Trade Receivables II LLC',
      description: 'HQ: United States',
    },
    {
      company: 'Xerox Trinidad Limited',
      description: 'HQ: Trinidad & Tobago',
    },
    {
      company: 'Xerox XF Holdings (Ireland) Limited',
      description:
        'HQ: Dublin, Co. Dublin | Ireland; Primary Industry: Data Processing and Outsourced Services',
    },
    {
      company: 'Xerox Finance (Ireland) Limited',
      description: 'HQ: United Kingdom; Primary Industry: Consumer Finance',
    },
    {
      company: 'XESystems',
      description:
        'HQ: East Rochester, New York | United States; Primary Industry: IT Consulting and Other Services',
    },
    {
      company: 'XESystems Canada Inc.',
      description: 'HQ: Canada',
    },
    {
      company: 'XMEIBL',
      description: 'HQ: United States',
    },
    {
      company: 'XMPie Inc.',
      description:
        'HQ: New York, New York | United States; Primary Industry: Application Software',
    },
    {
      company: 'XMPie Ltd.',
      description:
        'HQ: Netanya | Israel; Primary Industry: Application Software',
    },
    {
      company: 'Zoom Imaging Solutions, Inc.',
      description:
        'HQ: Roseville, California | United States; Primary Industry: Distributors',
    },
  ],
};
